import { render } from "./IDetail.vue?vue&type=template&id=4e1d55fc"
import script from "./IDetail.vue?vue&type=script&lang=js"
export * from "./IDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__